// extracted by mini-css-extract-plugin
module.exports = {"makerGrey":"#626262","app":"app_app__2QGHZ"};